import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Nav = styled.nav`
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  gap: 0.6rem;
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 40px;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(255,255,255,0.6);
`;

const NavItem = styled(motion.button)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${p => p.active ? '#334155' : 'transparent'};
  box-shadow: ${p => p.active ? '0 4px 12px rgba(51,65,85,0.3)' : 'none'};
  transition: background 0.2s, box-shadow 0.2s;
  font-size: 1.3rem;
  position: relative;
`;

const Tooltip = styled.span`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s;

  ${NavItem}:hover & {
    opacity: 1;
  }
`;

const items = [
  { path: '/dashboard',   icon: '🏠', label: 'Início' },
  { path: '/pedidos',     icon: '📅', label: 'Agenda' },
  { path: '/financeiro',  icon: '💰', label: 'Financeiro' },
  { path: '/editor/servicos', icon: '💅', label: 'Serviços' },
  { path: '/configuracoes', icon: '⚙️', label: 'Config' },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Nav>
      {items.map(item => (
        <NavItem
          key={item.path}
          active={location.pathname === item.path ? 1 : 0}
          whileTap={{ scale: 0.88 }}
          onClick={() => navigate(item.path)}
          title={item.label}
        >
          {item.icon}
          <Tooltip>{item.label}</Tooltip>
        </NavItem>
      ))}
    </Nav>
  );
};

export default BottomNav;
